import greg_photo from '../../static/staff_bio/greg.png'
import matthew_photo from '../../static/matthew.png'
import jaronn_photo from '../../static/staff_bio/jaronn.png'



export const staffData = [
  {
    id: 1,
    name: "Greg Wegrzynowicz",
    bio: "Coach Greg Wegrzynowicz is a USA Basketball licensed coach, National Academy of Sports Medicine Certified Personal Trainer, and Marine Corps Veteran that has over 12 years of experience coaching basketball in the Chicagoland area with clubs and schools including All In Athletics, Full Package, Illinois Central Elite, Queen of All Saints, and Baker Demonstration School.",
    img: greg_photo,
  },
   {
    id: 2,
    name: "Makyla McNeal",
    bio: 'Makyla McNeal is a highly experienced basketball player and trainer with 13 years of playing experience. She was a 3-year varsity starter on a Top-5 Indiana HS team. She is known for her strong basketball IQ and versatility in the post, Makyla received 6 college offers across NAIA and JUCO Divisions 1, 2, and 3, with additional interest from NCAA Division III programs. She has experience training athletes of all ages and is passionate about helping people develop their skills, confidence, and same love for the game she has.',
    img: jaronn_photo,
  },
  {
    id: 3,
    name: "Matthew Fields",
    bio: 'Coach Matthew Fields is a dedicated mentor and former multi-sport athlete, having excelled in both basketball and football. As a certified Double-Goal Coach, he embraces the philosophy of coaching not only for winning but also for teaching life lessons that extend far beyond the game. With a passion for reaching children through the love of sports, Coach Matthew focuses on building confidence, character, and resilience in every student he works with. He believes in the transformative power of sports to teach teamwork, discipline, and self-belief, and he strives to instill these values both on and off the court. Whether guiding a player to refine their skills or offering encouragement in their personal growth, Coach Matthew is committed to creating a positive, uplifting environment where young athletes can thrive. His dedication to nurturing each student’s potential makes him an invaluable part of the 606 Academy team.',
    // img: "chris",
    img: matthew_photo,
  },
   
]